module.exports = __webpack_public_path__ + "img/bg-banner-account.be648712.png";